import * as moment from 'moment';
import * as numeral from 'numeral/numeral';

export class Formatters {
    static maxAllowedDecimalPlaces = 5;

    static dateFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L') : val) : '';

    static datetimeFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L LT') : val) : '';

    static timeFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('LT') : moment.isDuration(val) ? moment.utc(val.asMilliseconds()).format('LT') : val) : '';

    //static numberFormatterTwoDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.00') : '';

    //static numberFormatterThreeDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.000') : '';

    //static numberFormatterFourDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.0000') : '';

    //static numberFormatterInteger = (row, cell, val) => val != null ? numeral(val).format('0,0') : '';

    static readonly checkedCssClass = 'fa-check-square-o';
    static readonly uncheckedCssClass = 'fa-square-o';
    static booleanFormatter = (row, cell, val) => `<i class="fa ${val ? Formatters.checkedCssClass : Formatters.uncheckedCssClass}"></i>`;

    static numberFormatter = (row: number, cell: number, val: any, decimalPlaces: number) =>
        val != null
            ? numeral(val).format(Formatters.getNumeralFormatString(decimalPlaces))
            : '';

    static numberCustomFormatter = (row: number, cell: number, val: any, decimalPlaces: number) =>{
        let res = parseFloat(val);
        return !isNaN(res)
            ? numeral(res).format(Formatters.getNumeralFormatString(decimalPlaces))
            : val;
    }

    static getNumeralFormatString = (decimalPlaces: number): string => {
        return `0,0${decimalPlaces > 0
            ? `.${new Array(Math.min(decimalPlaces, Formatters.maxAllowedDecimalPlaces) + 1).join('0')}`
            : ''}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/formatters.ts